"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ajv = _interopRequireDefault(require("ajv"));

var _jsonSchemaDraft = _interopRequireDefault(require("ajv/lib/refs/json-schema-draft-06.json"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var ajv = new _ajv["default"]();
ajv.addMetaSchema(_jsonSchemaDraft["default"]);
var getSchemaValidator = ajv.compile.bind(ajv);
var _default = getSchemaValidator;
exports["default"] = _default;